import { useState } from "react";
import { BotMessage } from "../../components/BotMessage";
import { TurnMessages } from "../../components/TurnMessages";
import { QuickReplies } from "../../components/QuickReplies";
import { ChatTurnLayout } from "../../components/ChatTurnLayout";
import { useTurnMessages } from "../../hooks/useTurnMessages";
import { chatCopy, getWelcomeLines } from "../../engine/copy";

const START = "start";
const QUESTIONS = "questions";
const QUESTIONS_LABEL = "Ce întrebări?";

interface WelcomeTurnProps {
  firstName?: string | null;
  onStart: () => void;
}

// The greeting before the first question. Nothing is saved: starting only
// lets the chat ask its first step.
export function WelcomeTurn({ firstName, onStart }: WelcomeTurnProps) {
  const { messages, addUser, addBot } = useTurnMessages();
  const [hasAskedQuestions, setHasAskedQuestions] = useState(false);

  const handleSelect = (id: string) => {
    if (id === START) {
      onStart();
      return;
    }

    addUser(QUESTIONS_LABEL);
    addBot(chatCopy.welcomeQuestions);
    setHasAskedQuestions(true);
  };

  return (
    <ChatTurnLayout
      messageCount={messages.length}
      thread={
        <>
          <BotMessage lines={getWelcomeLines(firstName)} />
          <TurnMessages messages={messages} />
        </>
      }
      actions={
        <QuickReplies
          replies={[
            { id: START, label: `${chatCopy.welcomeStart} 👍` },
            ...(hasAskedQuestions
              ? []
              : [{ id: QUESTIONS, label: QUESTIONS_LABEL }]),
          ]}
          onSelect={handleSelect}
        />
      }
    />
  );
}
